import { Routes, RouterModule } from '@angular/router';
import { ServicesListComponent } from './services-list/ServicesListComponent';
import { ParentNavigateComponent } from './parent-navigate/ParentNavigateComponent';
import { OtherParentNavigateComponent } from './other-parent-navigate/OtherParentNavigateComponent'
import { CalendarComponent } from '../common/modules/shared/components/calendar/CalendarComponent';
const appRoutes: Routes = [
  { path: "", component: ServicesListComponent },
  { path: "parents", component: ParentNavigateComponent },
  { path: "other-parents", component: OtherParentNavigateComponent },
  { path: "calendars", component: CalendarComponent },
];

export const appRoutingProviders: any[] = [

];

export const routing = RouterModule.forRoot(appRoutes);


// WEBPACK FOOTER //
// ./src/services/AppRouting.ts